<template>
  <section
    class="
      actions-container
      d-flex flex-column flex-md-row align-md-center
      py-0 pb-6
    "
    style="gap: 28px;"
  >
    <SearchBar class="flex-grow-1" style="min-width: 250px;" />

    <div
      class="
        custom-gap
        d-flex align-center
      "
    >
      <p class="my-0 h6 text-no-wrap">
        Nombre de résultats : {{ total }}
      </p>
      <v-spacer />

      <ListTopActions
        v-if="actions.length"
        :actions="actions"
        :create-permission="createPermission"
        @action-click="$emit('action-click', $event)"
      />
    </div>
  </section>
</template>

<script>
import SearchBar from '@/components/search/SearchBar';
import ListTopActions from '@/components/dynamic/list/components/ListTopActions.vue';

export default {
  name: 'ListToolbar',
  components: {
    SearchBar,
    ListTopActions
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    actions: {
      type: Array,
      default: () => []
    },
    createPermission: {
      type: String,
      default: ''
    }
  }
};
</script>

<style>
.actions-container {
  container-type: inline-size;
  container-name: actions-container;
}

.custom-gap {
  gap: 16px;
  @media (min-width: 768px) {
    gap: 46px;
  }
}
</style>
